import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Categoria } from 'app/entities/categoria';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  constructor(private http:HttpClient) {}

  categoriasDeUnaEmpresa({empresa}):Observable<Array<Categoria>>{
    console.log("hola");
    
    return this.http.get<Array<Categoria>>(`${environment.api}sms/${empresa}/categorias`)
  }

  mensajesDeUnaEmpresaPorCategorias({empresa,categoria}){
    return this.http.get(`${environment.api}sms/${empresa}/${categoria}`)
  }
}
